import {Document, DocumentRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell, Typography} from "@mui/material";
import {dateToString} from "../../../../components/utils/dates";
import {fullName, relative} from "../../../../components/kit";
import {ReviewStatusChip} from "./review_status";

export const DocumentListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Document> = {
		title: "Documentos de empresa",
		onClick: "/app/admin/compliance/document",
		headers: [
			{title: "Tema"},
			{title: "Título"},
			{title: "Responsable"},
			{title: "Próxima revisión"},
			{title: "Estado"},
		],
		decorator: (bean: Document) =>
			<>
				<TableCell sx={{color: "text.secondary"}}>{bean.topic?.name}</TableCell>
				<TableCell>
					<Typography variant="body2" fontWeight={600} noWrap title={bean.title}>{bean.title}</Typography>
				</TableCell>
				<TableCell>{bean.reviewOwner ? fullName(bean.reviewOwner) : ""}</TableCell>
				<TableCell>
					{bean.nextReviewDate ? (
						<>
							<Typography variant="body2" sx={{fontVariantNumeric: "tabular-nums"}}>{dateToString(bean.nextReviewDate)}</Typography>
							<Typography variant="caption" color="text.secondary">{relative(bean.nextReviewDate)}</Typography>
						</>
					) : <Typography variant="body2" color="text.disabled">—</Typography>}
				</TableCell>
				<TableCell><ReviewStatusChip status={bean.reviewStatus}/></TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(DocumentRestControllerApiFactory);
			return ctrl.pageDocument(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};